import { BASE_URL, SOMS_API_KEY, SUPPLIER_DESTINATION_MAPPING_ENDPOINT } from "services/CONSTANTS";
import { REMOVE_SUPPLIER_DESTINATION_MAPPING_FAILURE, REMOVE_SUPPLIER_DESTINATION_MAPPING_REQUEST, REMOVE_SUPPLIER_DESTINATION_MAPPING_RESET, REMOVE_SUPPLIER_DESTINATION_MAPPING_SUCCESS } from "./action-type"
import { Delete } from "services/apiService";

export const removeSupplierDestinationMappingAction = (payload) => {
    return (dispatch) => {
        dispatch(removeSupplierDestinationMappingRequest());
        let apiUrl = `${BASE_URL}${SUPPLIER_DESTINATION_MAPPING_ENDPOINT}?apikey=${SOMS_API_KEY}`;
        const request = {
            url: apiUrl,
            params: payload
        };
        Delete(request)
            .then((response) => {
                if (response.status === 200) {
                    dispatch(removeSupplierDestinationMappingSuccess(response));
                } else {
                    dispatch(removeSupplierDestinationMappingFailure(response));
                }
            })
            .catch((err) => {
                dispatch(removeSupplierDestinationMappingFailure(err));
            });
    }
}

const removeSupplierDestinationMappingRequest = () => {
    return {
        type: REMOVE_SUPPLIER_DESTINATION_MAPPING_REQUEST
    }
}

const removeSupplierDestinationMappingSuccess = (response) => {
    return {
        type: REMOVE_SUPPLIER_DESTINATION_MAPPING_SUCCESS,
        removeSupplierDestinationMappingResponse: response
    }
}

const removeSupplierDestinationMappingFailure = (error) => {
    return {
        type: REMOVE_SUPPLIER_DESTINATION_MAPPING_FAILURE,
        removeSupplierDestinationMappingResponse: error
    }
}

export const removeSupplierDestinationMappingReset = () => {
    return {
        type: REMOVE_SUPPLIER_DESTINATION_MAPPING_RESET
    }
}